import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Sign in with Apple — Apple Human Interface Guidelines: black button, white
 * Apple logo, "Sign in with Apple", corner radius and height matching the
 * other primary sign-in buttons on the screen.
 *
 * The backend owns the OAuth handshake because Apple POSTs its form_post
 * callback to the redirect URI, which a SPA route cannot consume.
 */
export default function AppleSignInButton({ label = "Sign in with Apple" }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    fetch(`${API}/auth/apple/status`)
      .then((r) => r.json())
      .then(setState)
      .catch(() => setState({ configured: false, missing: ["unreachable"] }));
  }, []);

  const go = () => {
    window.location.href = `${API}/auth/apple/start?mode=login`;
  };

  const ready = !!state?.configured;

  return (
    <div>
      <button
        type="button"
        data-testid="sso-apple-btn"
        onClick={go}
        disabled={!ready}
        aria-label={label}
        className="w-full min-h-[56px] border-2 border-ink bg-black text-white py-3.5 font-mono uppercase text-sm tracking-widest inline-flex items-center justify-center gap-3 shadow-hard hover:-translate-y-0.5 hover:shadow-hard-lg transition-transform disabled:opacity-40 disabled:hover:translate-y-0 disabled:cursor-not-allowed"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M17.05 12.66c.02 2.62 2.3 3.49 2.33 3.5-.02.06-.37 1.25-1.2 2.48-.73 1.06-1.48 2.11-2.67 2.13-1.17.02-1.55-.69-2.88-.69-1.34 0-1.74.67-2.85.71-1.14.04-2.01-1.14-2.74-2.2-1.6-2.3-2.82-6.51-1.18-9.35.81-1.41 2.27-2.3 3.85-2.33 1.13-.02 2.2.76 2.88.76.69 0 1.98-.94 3.34-.8.57.02 2.17.21 3.19 1.57-.08.05-1.91 1.12-1.89 3.33M14.9 4.5c.61-.74 1.02-1.77.91-2.79-.9.04-1.98.6-2.61 1.34-.57.65-1.06 1.7-.93 2.7 1 .08 2.02-.51 2.63-1.25" />
        </svg>
        {label}
      </button>
      {state && !ready && (
        <div className="mt-1 font-mono text-[10px] text-muted-foreground text-center"
             data-testid="apple-pending-note">
          Apple sign-in switches on as soon as the Apple developer keys are added.
        </div>
      )}
    </div>
  );
}
